// This is used in quasar.config.js to replace faker npm module
// on master build

/* eslint-env node */
module.exports = {}
